<template>
  <div class="no-bids d-flex align-center justify-center mt-14">
    <div class="text-center">
      <v-img class="mb-6 mx-auto" src="@/assets/img/docs.png" width="72px"></v-img>
      <h3 class="font font--h3 mb-2">У вас пока нет заявок</h3>
      <p class="font font--p-sm mb-6">Создайте свою первую заявку</p>
      <v-btn :disabled="!canCreateApp" color="primary" class="mb-sm-16 mb-4" @click="showNewBidModal(true)"
        >+ Новая заявка</v-btn
      >

      <Information class="mt-sm-2 mx-sm-10" />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import Information from "@/components/bids/Information.vue";
export default {
  methods: {
    ...mapMutations("common", ["showNewBidModal"]),
  },
  computed: mapGetters("profile", ["canCreateApp"]),
  components: {
    Information,
  },
};
</script>

<style lang="scss" scoped>
.no-bids {
  min-height: 350px;
}
</style>
